import React, { useState, useEffect } from "react";
import { Box, TextField, Typography } from "@mui/material";
import "./Edit.css";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import apiService from "../../utils/apiservice";

const EditCustomer = ({ open, onClose, customer, onSave }) => {
    const [customerData, setCustomerData] = useState({
        title: "",
        organization_email: "",
        customer_address: "",
        contact_person_name: "",
        contact_person_email: "",
        contact_person_designation: "",
        contact_no: "",
    });

    const [errors, setErrors] = useState({});

    useEffect(() => {
        if (open && customer) {
            setCustomerData({
                title: customer.customer_name || "",
                organization_email: customer.organization_email || "",
                customer_address: customer.customer_address || "",
                contact_person_name: customer.contact_person_name || "",
                contact_person_email: customer.contact_person_email || "",
                contact_person_designation: customer.contact_person_designation || "",
                contact_no: customer.contact_no || "",
            });
            setErrors({});
        }
    }, [open, customer]);

    // Validation regex
    // Customer Name
    const customerNameRegex =
        /^(?=.*[a-zA-Z])[a-zA-Z0-9]+( [a-zA-Z0-9]+)*$/;

    // Contact Person Name

    const nameRegex = /^[A-Za-z]{2,20}$/;
    // Email
    const emailRegex =
        /^(?!.*\.\.)(?!\.)([A-Za-z0-9._%+-]+)@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/;

    // Phone
    const phoneRegex = /^[6-9]\d{9}$/;

    // Designation
    const designationRegex = /^[A-Za-z0-9 ]{2,50}$/;

    // Address
    const addressRegex = /^[a-zA-Z0-9\s,./-]{5,100}$/;

    const handleChange = (e) => {
        let { name, value } = e.target;

        // Customer Name
        if (name === "customer_name") {
            value = value.replace(/^\s+/, "");
            value = value.replace(/\s{2,}/g, " ");
        }

        // Contact Person Name
        // Contact Person Name
        if (name === "contact_person_name") {
            value = value.replace(/^\s+/, "");
            value = value.replace(/\s{2,}/g, " ");
        }
        // Designation
        if (name === "contact_person_designation") {
            value = value.replace(/[^A-Za-z0-9 ]/g, "");
            value = value.replace(/^\s+/, "");
            value = value.replace(/\s{2,}/g, " ");
        }

        // Address
        if (name === "customer_address") {
            value = value.replace(/^\s+/, "");
            value = value.replace(/\s{2,}/g, " ");
        }

        // Emails
        if (
            name === "organization_email" ||
            name === "contact_person_email"
        ) {
            value = value.replace(/^\s+/, "").toLowerCase();
        }

        // Phone
        if (name === "contact_no") {
            value = value.replace(/\D/g, "").slice(0, 10);
        }

        setCustomerData((prev) => ({
            ...prev,
            [name]: value,
        }));

        validateField(name, value);
    };
    const validateField = (name, value) => {
        let error = "";

        switch (name) {
            case "customer_name":
                if (!value) {
                    error = "Customer name is required";
                } else if (value.length < 2 || value.length > 50) {
                    error = "Customer name must be between 2 and 50 characters";
                } else if (!customerNameRegex.test(value)) {
                    error =
                        "Only letters, numbers and single spaces are allowed";
                }
                break;

            case "organization_email":
            case "contact_person_email":
                if (!value) {
                    error = "Email is required";
                } else if (value.length < 2 || value.length > 50) {
                    error = "Email must be between 2 and 50 characters";
                } else if (value.includes("..")) {
                    error = "Multiple dots are not allowed";
                } else if (
                    value.startsWith(".") ||
                    value.endsWith(".")
                ) {
                    error = "Dot not allowed at start/end";
                } else if (!emailRegex.test(value)) {
                    error = "Invalid email format";
                }
                break;

            case "customer_address":
                if (!value) {
                    error = "Address is required";
                } else if (
                    value.length < 5 ||
                    value.length > 100
                ) {
                    error =
                        "Address must be between 5 and 100 characters";
                } else if (!addressRegex.test(value)) {
                    error = "Invalid address";
                }
                break;

            case "contact_person_name":
                if (!value) {
                    error = "Contact person name is required";
                } else if (value.length < 2 || value.length > 50) {
                    error =
                        "Contact person name must be between 2 and 50 characters";
                } else if (!customerNameRegex.test(value)) {
                    error =
                        "Only letters, numbers and single spaces are allowed";
                }
                break;
            case "contact_person_designation":
                if (!value) {
                    error = "Designation is required";
                } else if (
                    value.length < 2 ||
                    value.length > 50
                ) {
                    error =
                        "Designation must be between 2 and 50 characters";
                } else if (!designationRegex.test(value)) {
                    error = "Special characters are not allowed";
                }
                break;

            case "contact_no":
                if (!value) {
                    error = "Contact number is required";
                } else if (!phoneRegex.test(value)) {
                    error =
                        "Must start from 6-9 and be exactly 10 digits";
                }
                break;

            default:
                break;
        }

        setErrors((prev) => ({
            ...prev,
            [name]: error,
        }));
    };




    const validateForm = () => {
        validateField("customer_name", customerData.title);
        validateField(
            "organization_email",
            customerData.organization_email
        );
        validateField(
            "customer_address",
            customerData.customer_address
        );
        validateField(
            "contact_person_name",
            customerData.contact_person_name
        );
        validateField(
            "contact_person_email",
            customerData.contact_person_email
        );
        validateField(
            "contact_person_designation",
            customerData.contact_person_designation
        );
        validateField("contact_no", customerData.contact_no);

        return Object.values(errors).every((e) => !e);
    };



    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!validateForm()) return;

        try {
            const customerId = customer.customer_id;

            const response = await apiService.post(
                `/api/customer/update/${customerId}/`,
                {
                    ...customerData,
                    email: customerData.organization_email,
                    address: customerData.customer_address,
                }
            );

            toast.success(response.data?.message || "Customer updated!");

            onSave({ ...customer, ...customerData });

            setTimeout(() => onClose(), 300);
        } catch (error) {
            const msg =
                error.response?.data?.error ||
                error.response?.data?.message ||
                "Update failed";

            toast.error(msg);
        }
    };

    const handleCancel = () => {
        setErrors({});
        onClose();
    };

    if (!open) return null;

    return (
        <>
            <div className="edit-site-modal">
                <Box
                    component="form"
                    className="edit-site-container edit-site-form"
                    onSubmit={handleSubmit}
                >
                    <Typography className="edit-site-title">
                        Edit Customer
                    </Typography>

                    <TextField
                        label="Customer Name"
                        name="customer_name"
                        value={customerData.title}
                        onChange={handleChange}
                        error={!!errors.customer_name}
                        helperText={errors.customer_name}
                    />

                    <TextField
                        label="Organization Email"
                        name="organization_email"
                        value={customerData.organization_email}
                        onChange={handleChange}
                        error={!!errors.organization_email}
                        helperText={errors.organization_email}
                    />

                    <TextField
                        label="Address"
                        name="customer_address"
                        value={customerData.customer_address}
                        onChange={handleChange}
                        error={!!errors.customer_address}
                        helperText={errors.customer_address}
                    />

                    <TextField
                        label="Contact Person Name"
                        name="contact_person_name"
                        value={customerData.contact_person_name}
                        onChange={handleChange}
                        error={!!errors.contact_person_name}
                        helperText={errors.contact_person_name}
                    />

                    <TextField
                        label="Contact Person Email"
                        name="contact_person_email"
                        value={customerData.contact_person_email}
                        onChange={handleChange}
                        error={!!errors.contact_person_email}
                        helperText={errors.contact_person_email}
                    />

                    <TextField
                        label="Designation"
                        name="contact_person_designation"
                        value={customerData.contact_person_designation}
                        onChange={handleChange}
                        error={!!errors.contact_person_designation}
                        helperText={errors.contact_person_designation}
                    />

                    <TextField
                        label="Contact No"
                        name="contact_no"
                        value={customerData.contact_no}
                        onChange={handleChange}
                        error={!!errors.contact_no}
                        helperText={errors.contact_no}
                    />

                    <div className="edit-btn-wrapper">
                        <button
                            type="button"
                            className="cancel-btn"
                            onClick={handleCancel}
                        >
                            Cancel
                        </button>

                        <button type="submit" className="edit-btn">
                            Save Changes
                        </button>
                    </div>
                </Box>
            </div>

            {/* <ToastContainer position="top-right" autoClose={3000} /> */}
        </>
    );
};

export default EditCustomer;